import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { BadgesContextualTitle, BadgeTagWithIconsTitle, NumberOfBadge, NumberOfPills, PillsContextualTitle, RoundedPillsWithIconsTitle, TagPills, UIKits } from "../../../constants";
import { BadgeIconData, BadgesContextualSubTitle, BadgesData, BadgeIconSubTitle, NumberBadgeSubTitle, PillsIconSubTitle, NumberPillsSubTitle, PillsContextualSubTitle } from "../../../data/uiKits/Tag&Pills";
import BadgeButton from "./BadgeButton";
import BadgeHeading from "./BadgeHeading";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonBadges from "./CommonBadges";

const TagAndPillsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TagPills} parent={UIKits} />
      <Container fluid>
        <Row>
          <CommonBadges title={BadgesContextualTitle} span={BadgesContextualSubTitle} data={BadgesData} />
          <CommonBadges title={PillsContextualTitle} span={PillsContextualSubTitle} data={BadgesData} roundedPills />
          <CommonBadges title={NumberOfBadge} span={NumberBadgeSubTitle} data={BadgesData} number />
          <CommonBadges title={NumberOfPills} span={NumberPillsSubTitle} data={BadgesData} number className="rounded-circle badge-p-space" />
          <CommonBadges title={BadgeTagWithIconsTitle} span={BadgeIconSubTitle} data={BadgeIconData} icon />
          <CommonBadges title={RoundedPillsWithIconsTitle} span={PillsIconSubTitle} data={BadgeIconData} icon className="rounded-circle p-2" />
          <BadgeHeading />
          <BadgeButton />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TagAndPillsContainer;
